"use client";
export { SliderMask as default } from "../../../_Builtin/Slider";
